import React from "react";
import Header from "../header/Header";
import { Box, Stack } from "@mui/material";
import Sidebar from "../sidebar/Sidebar";
import {
  HEADER_HEIGHT,
  SIDEBAR_MAXWIDTH,
  SIDEBAR_MINWIDTH,
} from "../../../../utils/ui.constants";
import useLocalStorage from "../../../../hooks/useLocalStorage";

function MainLayout({ children }: { children: React.ReactNode }) {
  const [expandSidebar, setExpandSidebar] = useLocalStorage<boolean>(
    "menu_mode",
    true
  );

  const toggleSidebar = () => {
    setExpandSidebar(!expandSidebar);
  };

  return (
    <>
      <Header toggleSideBar={toggleSidebar} />
      <Stack
        direction="row"
        sx={{ width: "100%", height: `calc(100vh - ${HEADER_HEIGHT})` }}
      >
        <Sidebar expand={expandSidebar} />
        <Box
          sx={{
            p: 2,
            backgroundColor: "background.default",
            width: `calc(100% - ${
              expandSidebar ? SIDEBAR_MAXWIDTH : SIDEBAR_MINWIDTH
            })`,
            height: `calc(100vh - ${HEADER_HEIGHT})`,
            transition: "all linear 0.1s",
          }}
        >
          {children}
        </Box>
      </Stack>
    </>
  );
}

export default MainLayout;
